module.exports = __webpack_public_path__ + "static/media/2DGACM4.9840ae7b.jpg";